module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970-desktop/0069.jpg?v=c661a050";